import { isCustomFieldValueEmpty } from '../isCustomFieldValueEmpty';
import { CustomField } from '../useLazyCustomFields';

type GetEmptyCustomFieldsOptions = {
  /** The custom fields. */
  customFields: readonly CustomField[];
  /** Whether to only count the required attributes. */
  onlyRequired?: boolean;
};

/** Return the custom fields that have empty values. */
export function getEmptyCustomFields({
  customFields,
  onlyRequired = false,
}: GetEmptyCustomFieldsOptions): readonly CustomField[] {
  return customFields.filter(
    ({ attribute: { is_required }, value }) =>
      (!onlyRequired || is_required) && isCustomFieldValueEmpty(value),
  );
}
